import { useOrgSharepointFile } from "@/hooks/useOrgSharepointFile";
import { useProjectFile } from "@/hooks/useProjectFile";
import { Enums } from "@/types/supabase";
import React, { createContext } from "react";

type SharepointFileContextValue = {
  useProjectFile: (fileId: string | null) => {
    url: string | undefined;
    isLoading: boolean;
    error: Error | undefined;
  };
};

// eslint-disable-next-line react-refresh/only-export-components
export const SharepointFileContext = createContext<SharepointFileContextValue | null>(null);

export const SharepointFileProvider: React.FC<{
  children: React.ReactNode;
  convoType: Enums<"convo_type">;
}> = ({ children, convoType }) => {
  return (
    <SharepointFileContext.Provider
      value={{
        useProjectFile: convoType === "org" ? useOrgSharepointFile : useProjectFile,
      }}
    >
      {children}
    </SharepointFileContext.Provider>
  );
};
